import { useEffect } from "react";
import { useLoaderData, useRevalidator } from "react-router-dom";
import { useBreakpoint } from "@chakra-ui/react";
import client from "../../../../helpers/Client";

import ServiceListTableView from "./ServiceListTableView";
import ServiceListMobile from "./ServiceListMobile";

export async function ServiceLoader() {
  const serviceRecordsResp = await client.get("/service_records_by_units/");
  return serviceRecordsResp.data;
}

export default function ServiceList() {
  const bp = useBreakpoint({ ssr: false });
  const serviceRecords = useLoaderData();
  const revalidator = useRevalidator();

  // Auto-refresh data every 30 seconds to keep table updated
  useEffect(() => {
    const interval = setInterval(() => {
      revalidator.revalidate();
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, [revalidator]);

  const Component =
    {
      base: ServiceListMobile,
      sm: ServiceListTableView,
      md: ServiceListTableView,
      lg: ServiceListTableView,
    }[bp] || ServiceListTableView;
  return <Component services={serviceRecords} />;
}
